<template>
  <Content id="scanTestTubeLog">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务" prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="学校" prop="schoolId">
              <el-select v-model.trim="search.schoolId" placeholder="学校"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检项目" :label-width="75">
              <Select v-model="search.projectId" style="min-width: 120px" :clearable="true">
                <Option v-for="item in projectNames" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="检查状态" :label-width="75">
              <Select v-model="search.checkStatus" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in checkStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.sources" style="min-width: 95px;" :clearable="true">
                <Option v-for="item in sourcesList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="barCode" label="条形码" min-width="130"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="80"/>
      <el-table-column fixed align="center" prop="idCard" label="证件号码" min-width="170"/>
      <el-table-column fixed align="center" prop="taskName" label="体检任务" min-width="200"/>
      <el-table-column fixed align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column fixed align="center" prop="openid" label="微信标识" min-width="250"/>
      <el-table-column fixed align="center" prop="projectName" label="体检项目" min-width="100"/>
      <el-table-column align="center" prop="checkStatus" label="检查状态" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.checkStatus === 1 ? 'danger' : row.checkStatus === 2 ? 'primary' : 'warning'" disable-transitions>{{  row.checkStatus == 1 ? '未检' : row.tubeStatus == 2 ? '已检' : '部分已检'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sources" label="来源" min-width="100">
        <template slot-scope="{row}">{{ row.sources == 1 ? '小程序' : row.sources == 2 ? 'pc端' : '导入' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="200"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="createTime" label="操作时间" min-width="180"/>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {_page} from "@/services/operationRecord/physicalItemsLog.js";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
export default {
  name: "physicalItemsLog",
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        barCode:"",
        taskId:"",
        schoolId:"",
        name:"",
        idCard:"",
        openid:"",
        projectId:"",
        checkStatus:"",
        sources:"",
      },
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
      checkStatusList:[
        {label: '全部', value: ''},
        {label: '未检', value: 1},
        {label: '已检', value: 2},
        {label: '部分已检', value: 3},
      ],
      sourcesList:[
        {label: '全部', value: ''},
        {label: '小程序', value: 1},
        {label: 'pc端', value: 2},
        {label: '导入', value: 3},
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    if (!this.$userSession.checkInstitutionId()) {
      return;
    }

    await this.applyProjectName();
    await this.applyTaskList();
    await this.applySchoolsList();
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}

</style>
